
import React from "react";
import { X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useTheme } from "@/components/theme-provider";

interface ChatWidgetHeaderProps {
  onClose: () => void;
}

export function ChatWidgetHeader({ onClose }: ChatWidgetHeaderProps) {
  const { theme } = useTheme();
  const isDarkMode = theme === "dark";
  
  return (
    <div className={`bg-gold p-3 flex justify-between items-center text-white`}>
      <h3 className="font-medium">Gildy Assistente</h3>
      <Button 
        variant="ghost" 
        size="icon" 
        onClick={onClose} 
        className="h-8 w-8 hover:bg-white/20 text-white"
      >
        <X className="h-4 w-4" />
      </Button>
    </div>
  );
}
